<template>
    <el-dialog :title="dialogName" :visible.sync="dialogVisible" width="600px" :close-on-click-modal="false" :modal-append-to-body="true">
      <div class="main-box">
        <el-form ref="dataForm" id="dataForm" :model="temp" label-width="100px" label-suffix="：">
          <el-row :gutter="15">
            <el-col :span="24">
              <el-form-item  label="主题" prop="id">
                <el-radio v-model="temp.themeType" label="theme-default">上下主题</el-radio>
                <el-radio v-model="temp.themeType" label="theme-theme1">左右主题</el-radio>
                <el-radio v-model="temp.themeType" label="theme-theme2">疾控主题</el-radio>
                <el-radio v-model="temp.themeType" label="theme-theme3">子系统主题</el-radio>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <xr-button type="primary" @click="save()">确定</xr-button>
        <xr-button type="default" @click.native="dialogVisible = false">取消</xr-button>
      </div>
    </el-dialog>

</template>

<script>
    export default {
        name: "partyBSelect",
        data() {
          return {
            dialogName: '切换主题',
            dialogVisible: false,                                        //弹框
            temp: {
              themeType :'',
            }
          }
        },
        components: {

        },
        methods: {
          init(){
            this.dialogVisible = true;
            this.temp.themeType = this.$store.getters.themeType;
          },
          save(){
            //退出登陆
            let object = new Object();
            object.type = this.temp.themeType;
            this.$store.dispatch('theme/changeTheme', object)
            this.dialogVisible = false;
          }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/header/SwitchTheme.vue